export default [
  {
    path: 'forms',
    component: () => import('~/layouts/FormLayout.vue'),
    meta: { form: true },
    name: 'Forms',
    children: [
      {
        path: 'files',
        name: 'Forms.Files',
        component: () => import('~/views/forms/FilesPage.vue'),
        meta: { public: false },
      },
      {
        path: 'cards',
        name: 'Forms.Cards',
        component: () => import('~/views/forms/CardsPage.vue'),
        meta: { public: false },
      },
      {
        path: 'questionnaire',
        name: 'Forms.Questionnaire',
        component: () => import('~/views/forms/QuestionnairePage.vue'),
        meta: { public: false },
      },
    ],
  },
];
